import { TableCell, makeStyles, TableRow } from '@material-ui/core';
import React from 'react'
import { formatCurrencyPesos } from '../../../helpers/extraFunctions';
import { TIPO_INGRESO_MESA_ENTRADA } from '../../../utils/constants';
import IconEstado from '../../autorizaciones/UI/IconEstado';

const useRowStyles = makeStyles({
  root: {
    "& > *": {
      borderBottom: "unset",
    },
  },
});

const optionsfecha = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
};

export const ComprobantesRemitosItem = ({ item, tipoIngreso }) => {
  const classes = useRowStyles();

  return (
    <>
      {tipoIngreso === TIPO_INGRESO_MESA_ENTRADA.PRESTADOR_PROVEEDOR && (
        <TableRow className={classes.root} >
          {item?.idEstado === 3 && (
            <TableCell align="center">
              <IconEstado
                useColorTable={true}
                texto={'E'}
                backgroundColor={'green'}
                descripcion={'enviada'}
              />
            </TableCell>
          )}
          <TableCell align="left">{item?.idComprobante}</TableCell>
          <TableCell align="left">{item?.idComprobanteSV}</TableCell>
          <TableCell align="left">
            {item?.fechaRecepcion
              ? new Date(item?.fechaRecepcion).toLocaleString("es", optionsfecha)
              : null
            }
          </TableCell>
          <TableCell align="left">{item?.razonSocial}</TableCell>
          <TableCell align="left">{item?.descripcionTipoComprobante}</TableCell>
          <TableCell align="left" style={{ minWidth: 150 }}>
          {item?.nroSucursal
            ? `${item?.nroSucursal.toString().padStart((5), '0')}-${item?.nroFactura.toString().padStart((8), '0')}`
            : null
          }
          </TableCell>
          <TableCell align="left">{`${formatCurrencyPesos(item?.totalComprobante)}`}</TableCell>
          <TableCell align="left">{item?.descripcionDestino}</TableCell>
          <TableCell align="left">{item?.nroRemito ? item?.nroRemito : ''}</TableCell>
        </TableRow>
      )}
      {tipoIngreso === TIPO_INGRESO_MESA_ENTRADA.DOCUMENTACION && (
        <TableRow className={classes.root} >
          {item?.idEstado === 3 && (
            <TableCell align="center">
              <IconEstado
                useColorTable={true}
                texto={'E'}
                backgroundColor={'green'}
                descripcion={'enviada'}
              />
            </TableCell>
          )}
          <TableCell align="left">{item?.idComprobante}</TableCell>
          <TableCell align="left">{item?.idComprobanteSV}</TableCell>
          <TableCell align="left">
            {item?.fechaRecepcion
              ? new Date(item?.fechaRecepcion).toLocaleString("es", optionsfecha)
              : null
            }
          </TableCell>
          <TableCell align="left">
            {item?.fechaCarta
              ? new Date(item?.fechaCarta).toLocaleString("es", optionsfecha)
              : null
            }
          </TableCell>
          <TableCell align="left">{item?.caratula}</TableCell>
          <TableCell align="left">{item?.entregadoPor}</TableCell>
          <TableCell align="left">{item?.folios}</TableCell>
          <TableCell align="left">{item?.descripcionDestino}</TableCell>
          <TableCell align="left">{item?.nroRemito ? item?.nroRemito : ''}</TableCell>
        </TableRow>
      )}
    </>
  );
};



